import React from 'react';

const Nav = () => {
    return (
        <header>
            <nav className="navbar navbar-expand-xl nav_area sticky">
                <div className="container">
                    <div className="logo">
                        <a className="navbar-brand" href="https://utpl.edu.ec">
                            <img src={require('../images/logo.png')} width="100" height="30" alt="" />
                        </a>
                    </div>
                   
                </div>
            </nav>
        </header>
    );
}


export default Nav;